import { render, staticRenderFns } from "./ConsentOnechatCreate.vue?vue&type=template&id=a961854c&scoped=true&"
import script from "./ConsentOnechatCreate.vue?vue&type=script&lang=js&"
export * from "./ConsentOnechatCreate.vue?vue&type=script&lang=js&"
import style0 from "./ConsentOnechatCreate.vue?vue&type=style&index=0&id=a961854c&prod&scoped=true&lang=css&"
import style1 from "./ConsentOnechatCreate.vue?vue&type=style&index=1&id=a961854c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a961854c",
  null
  
)

export default component.exports